export default __webpack_public_path__ + "static/media/planet.0ac856b2.png";